import { dispatchHandler } from "../helpers/dispatchHandler";
import axios from "axios";
import {
    QUALIFICATION_VIEW_ALL,
    QUALIFICATION_VIEW_ALL_ERROR,
    QUALIFICATION_VIEW_ONE,
    QUALIFICATION_VIEW_ONE_ERROR,
} from "./type";
import secureLocalStorage from "react-secure-storage";

const header = {
    headers: { "access-token": secureLocalStorage.getItem("token") },
};

/**
 * viewAllQualification
 * @returns 
 */
export const viewAllQualification = (id) => async (dispatch) => {
    try {
        const URL = `/api/qualification/list/${id}`;
        const { data } = await axios.get(URL, header);
        dispatchHandler({
            type: QUALIFICATION_VIEW_ALL,
            data: data.qualification,
            dispatch,
        });
    } catch (error) {
        dispatchHandler({
            type: QUALIFICATION_VIEW_ALL_ERROR,
            data: error?.data?.error??"Network error",
            dispatch,
        });
    }
};
/**
 * viewAllQualification
 * @returns 
 */
export const viewOneQualification = (id) => async (dispatch) => {
    try {
        const URL = `/api/qualification/${id}`;
        const { data } = await axios.get(URL, header);
        dispatchHandler({
            type: QUALIFICATION_VIEW_ONE,
            data: data,
            dispatch,
        });
    } catch (error) {
        dispatchHandler({
            type: QUALIFICATION_VIEW_ONE_ERROR,
            data: error?.data?.error??"Network error",
            dispatch,
        });
    }
};
